export default __webpack_public_path__ + "static/media/headerGradient.e1d34c8e.jpg";